import {CourseSearchBlockProps} from "./types";
import {Card, Heading, Paragraph} from "@digdir/designsystemet-react";
import {Button} from "@digdir/designsystemet-react";

export function CourseSearchBlock({pageOfEvents, translations, courseSearchPage}: CourseSearchBlockProps) {
    return (
        <section className="w-full flex flex-col gap-4 my-10">
            {courseSearchPage && (
                <div className="flex justify-between items-center">
                    <Heading level={2} className="!mb-0">{courseSearchPage?.heading}</Heading>
                    {courseSearchPage?.link && (
                        <div className="md:block hidden">
                            <Button data-size="sm" variant="primary">
                                <a href={courseSearchPage.link} className="text-white no-underline">
                                    <Paragraph data-size="sm" className="!mb-0">{translations.seAll}</Paragraph>
                                </a>
                            </Button>
                        </div>
                    )}
                </div>
            )}

            {pageOfEvents && pageOfEvents.length > 0 ? pageOfEvents.map((event) => (
                    <Card
                        key={event.id}
                        data-size={"sm"}
                        className="flex flex-col gap-[7px] rounded-none border border-neutralNsf-subtle md:gap-2 xl:gap-[9px]"
                        asChild>
                        <a href={event.url}>
                            <Card.Block className={"flex flex-col gap-2"}>
                                <Heading level={3} className={"!mb-0"}>
                                    {event.name}
                                </Heading>
                                <Paragraph className={"!mb-0"}>{event.intro}</Paragraph>
                            </Card.Block>
                        </a>
                    </Card>
                )
            ) : (
                <div className="w-full flex justify-center">
                    <Paragraph data-size="sm" className="!mb-0">
                        {translations.noResults}
                    </Paragraph>
                </div>
            )}
        </section>
    );
}